import React from 'react';
import { compose } from 'redux';
import PropTypes from 'prop-types';
// Core components
import Avatar from 'components/core/Avatar';
import Tooltip from 'components/core/Tooltip';
// Models
import mDevice from 'models/device';
// Custom
import { deviceDataShape } from 'constants/PropTypesShapes';
import withPermissions from 'hocs/WithPermissions';
import AppIcon from 'components/icons/AppIcon';
import DeviceDataTip from './DeviceDataTip';

const DeviceStatusWidget = ({
  device, parentId, source, tooltipPermission, withDesc, withSimcard, withInstallation, hasPermission,
}) => {
  const { icon, color } = mDevice.status(device);

  // Build tooltip props
  const dataTipProps = {
    deviceId: device.id, source, parentId, withDesc, withSimcard, withInstallation,
  };

  if (tooltipPermission && hasPermission(tooltipPermission)) {
    return (
      <Tooltip
        light
        preventOverflowOnViewport
        content={
          <DeviceDataTip {...dataTipProps} />
        }
      >
        <Avatar
          size={32}
          backgroundColor={color}
        >
          <AppIcon id={icon} />
        </Avatar>
      </Tooltip>
    );
  }
  return (
    <Avatar
      size={32}
      backgroundColor={color}
    >
      <AppIcon id={icon} />
    </Avatar>
  );
};

DeviceStatusWidget.propTypes = {
  device: deviceDataShape.isRequired,
  source: PropTypes.oneOf(['installation', 'simcard', 'device', 'rollout', 'deviceSlave']).isRequired,
  parentId: PropTypes.number.isRequired,
  tooltipPermission: PropTypes.object,
  withDesc: PropTypes.bool,
  withSimcard: PropTypes.bool,
  withInstallation: PropTypes.bool,
  hasPermission: PropTypes.func.isRequired,
};

DeviceStatusWidget.defaultProps = {
  tooltipPermission: null,
  withDesc: false,
  withSimcard: false,
  withInstallation: false,
};

module.exports = compose(
  withPermissions,
)(DeviceStatusWidget);



// WEBPACK FOOTER //
// ./routes/app/routes/devices/assets/main/DeviceStatusWidget.js